<div
  class="ledger-overview tw-flex tw-flex-col tw-gap-4 tw-py-4 tw-text-gray-800 dark:tw-text-gray-100">
  <!-- Imports in progress banner -->
  <div
    *ngIf="(importsInProgress$ | async)?.importing || (importsInProgress$ | async)?.processing"
    class="tw-flex tw-shrink-0 tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-sky-200 dark:tw-border-sky-500/30 tw-bg-sky-50 dark:tw-bg-sky-500/10 tw-px-4 tw-py-2.5 tw-text-sm tw-text-sky-800 dark:tw-text-sky-200">
    <mat-progress-spinner mode="indeterminate" diameter="18"></mat-progress-spinner>
    Contacts are being imported — this page will refresh automatically when the import finishes.
  </div>

  <!-- Stat cards -->
  <div class="tw-grid tw-shrink-0 tw-grid-cols-1 sm:tw-grid-cols-2 xl:tw-grid-cols-4 tw-gap-4">
    <button
      type="button"
      (click)="setTab('new_company')"
      class="tw-flex tw-flex-col tw-text-left tw-rounded-xl tw-border tw-border-emerald-300 dark:tw-border-emerald-500/40 tw-bg-white dark:tw-bg-gray-800 tw-p-4 tw-min-h-[116px] tw-transition-all hover:tw-shadow-md dark:hover:tw-bg-gray-700"
      [ngClass]="{ 'tw-ring-2 tw-ring-emerald-400/60': activeTab === 'new_company' }">
      <div
        class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-600 dark:tw-text-gray-300">
        <span class="statDot tw-bg-emerald-500 dark:tw-bg-emerald-400"></span>
        Moved to a new company
      </div>
      <div
        class="tw-mt-2 tw-text-4xl tw-font-bold tw-leading-none tw-text-gray-900 dark:tw-text-white">
        <ng-container *ngIf="movedCount !== undefined">{{ movedCount | number }}</ng-container>
        <mat-spinner *ngIf="movedCount === undefined" [diameter]="28"></mat-spinner>
      </div>
      <div
        *ngIf="movedRecentCount !== undefined"
        class="tw-mt-2 tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
        {{ movedRecentCount | number }} in last {{ windowMonths | number }}
        {{ windowMonths === 1 ? 'month' : 'months' }}
      </div>
    </button>

    <button
      type="button"
      (click)="setTab('no_employer')"
      class="tw-flex tw-flex-col tw-text-left tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-bg-white dark:tw-bg-gray-800 tw-p-4 tw-min-h-[116px] tw-transition-all hover:tw-shadow-md dark:hover:tw-bg-gray-700"
      [ngClass]="{ 'tw-ring-2 tw-ring-amber-400/60': activeTab === 'no_employer' }">
      <div
        class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-600 dark:tw-text-gray-300">
        <span class="statDot tw-bg-amber-500 dark:tw-bg-amber-400"></span>
        No current employer
      </div>
      <div
        class="tw-mt-2 tw-text-4xl tw-font-bold tw-leading-none tw-text-gray-900 dark:tw-text-white">
        <ng-container *ngIf="noEmployerCount !== undefined">
          {{ noEmployerCount | number }}
        </ng-container>
        <mat-spinner *ngIf="noEmployerCount === undefined" [diameter]="28"></mat-spinner>
      </div>
      <div
        *ngIf="noEmployerCount !== undefined"
        class="tw-mt-2 tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
        company = None
      </div>
    </button>

    <div
      class="tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-bg-white dark:tw-bg-gray-800 tw-p-4 tw-min-h-[116px]">
      <div class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-300">Total contacts found</div>
      <div
        class="tw-mt-2 tw-text-4xl tw-font-bold tw-leading-none tw-text-gray-900 dark:tw-text-white">
        <ng-container
          *ngIf="verifiedCount !== undefined"
          >{{ verifiedCount | number }}</ng-container
        >
        <mat-spinner *ngIf="verifiedCount === undefined" [diameter]="28"></mat-spinner>
      </div>
      <div
        *ngIf="verifiedPct !== null"
        class="tw-mt-2 tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
        {{ verifiedPct }}% of ledger
      </div>
    </div>

    <div
      class="tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-bg-white dark:tw-bg-gray-800 tw-p-4 tw-min-h-[116px]">
      <div class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-300">Total ledger contacts</div>
      <div
        class="tw-mt-2 tw-text-4xl tw-font-bold tw-leading-none tw-text-gray-900 dark:tw-text-white">
        <ng-container *ngIf="contactCount !== undefined">{{ contactCount | number }}</ng-container>
        <mat-spinner *ngIf="contactCount === undefined" [diameter]="28"></mat-spinner>
      </div>
      <div
        *ngIf="contactCount !== undefined"
        class="tw-mt-2 tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
        uploaded
      </div>
    </div>
  </div>

  <ng-container *ngIf="!emptyLedger">
    <!-- Filter bar -->
    <div class="tw-flex tw-shrink-0 tw-flex-wrap tw-items-center tw-gap-3">
      <div
        class="tw-inline-flex tw-items-center tw-gap-1 tw-rounded-lg tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-bg-white dark:tw-bg-gray-800 tw-p-1">
        <button
          type="button"
          (click)="setTab('all')"
          class="tw-rounded-md tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-whitespace-nowrap tw-transition-colors"
          [ngClass]="activeTab === 'all'
            ? 'tw-bg-emerald-100 tw-text-emerald-800 dark:tw-bg-emerald-500/15 dark:tw-text-emerald-300'
            : 'tw-text-gray-600 hover:tw-bg-gray-100 dark:tw-text-gray-300 dark:hover:tw-bg-gray-700'">
          All changes
        </button>
        <button
          type="button"
          (click)="setTab('new_company')"
          class="tw-rounded-md tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-whitespace-nowrap tw-transition-colors"
          [ngClass]="activeTab === 'new_company'
            ? 'tw-bg-emerald-100 tw-text-emerald-800 dark:tw-bg-emerald-500/15 dark:tw-text-emerald-300'
            : 'tw-text-gray-600 hover:tw-bg-gray-100 dark:tw-text-gray-300 dark:hover:tw-bg-gray-700'">
          New company
        </button>
        <button
          type="button"
          (click)="setTab('no_employer')"
          class="tw-rounded-md tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-whitespace-nowrap tw-transition-colors"
          [ngClass]="activeTab === 'no_employer'
            ? 'tw-bg-amber-100 tw-text-amber-800 dark:tw-bg-amber-400/15 dark:tw-text-amber-300'
            : 'tw-text-gray-600 hover:tw-bg-gray-100 dark:tw-text-gray-300 dark:hover:tw-bg-gray-700'">
          No current employer
        </button>
      </div>

      <div
        class="tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-bg-white dark:tw-bg-gray-800 tw-py-1 tw-pl-2 tw-pr-3">
        <mat-checkbox
          [checked]="windowEnabled"
          (change)="toggleWindow($event.checked)"
          class="tw-text-sm">
          Started in the last
        </mat-checkbox>
        <input
          type="number"
          min="1"
          max="120"
          #monthsInput
          [value]="windowMonths"
          (change)="onWindowMonthsChange(monthsInput.value)"
          class="tw-w-16 tw-rounded-md tw-border tw-border-gray-300 dark:tw-border-gray-600 tw-bg-transparent tw-px-2 tw-py-1 tw-text-center tw-text-sm tw-text-gray-800 dark:tw-text-white" />
        <span class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-300">
          {{ windowMonths === 1 ? 'month' : 'months' }}
        </span>
        <span class="tw-h-5 tw-w-px tw-bg-gray-200 dark:tw-bg-gray-600"></span>
        <button
          *ngFor="let preset of windowPresets"
          type="button"
          (click)="setWindowPreset(preset)"
          class="tw-rounded-md tw-px-2 tw-py-1 tw-text-sm tw-transition-colors"
          [ngClass]="windowEnabled && windowMonths === preset
            ? 'tw-bg-emerald-100 tw-font-medium tw-text-emerald-800 dark:tw-bg-emerald-500/15 dark:tw-text-emerald-300'
            : 'tw-text-gray-600 hover:tw-bg-gray-100 dark:tw-text-gray-300 dark:hover:tw-bg-gray-700'">
          {{ preset }}
        </button>
      </div>

      <div
        class="tw-relative tw-ml-auto"
        [matTooltip]="searchDisabled ? 'Quick search is unavailable for ledgers over 1 million contacts. Use the Details tab to search.' : ''">
        <mat-icon
          class="searchIcon tw-absolute tw-left-2.5 tw-top-2.5 tw-text-gray-400 dark:tw-text-gray-500">
          search
        </mat-icon>
        <input
          type="text"
          #searchInput
          [value]="searchTerm"
          [disabled]="searchDisabled"
          (input)="onSearchInput(searchInput.value)"
          placeholder="Search person or company"
          class="tw-w-64 tw-max-w-full tw-rounded-lg tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-bg-white dark:tw-bg-gray-800 tw-py-2 tw-pl-9 tw-pr-3 tw-text-sm tw-text-gray-800 dark:tw-text-white placeholder:tw-text-gray-400 dark:placeholder:tw-text-gray-500 focus:tw-border-emerald-400 dark:focus:tw-border-emerald-500 disabled:tw-cursor-not-allowed disabled:tw-opacity-60" />
      </div>
    </div>

    <!-- Result count + download -->
    <div class="tw-flex tw-shrink-0 tw-flex-wrap tw-items-center tw-gap-3">
      <div class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-300">
        <ng-container *ngIf="tableLoading">Loading detected changes…</ng-container>
        <ng-container *ngIf="!tableLoading && !searchActive">
          Showing
          <span class="tw-font-semibold tw-text-gray-900 dark:tw-text-white">
            {{ displayRows.length | number }}
          </span>
          of
          <span class="tw-font-semibold tw-text-gray-900 dark:tw-text-white">
            {{ (tableCount ?? displayRows.length) | number }}
          </span>
          detected changes
        </ng-container>
        <ng-container *ngIf="!tableLoading && searchActive">
          Showing
          <span class="tw-font-semibold tw-text-gray-900 dark:tw-text-white">
            {{ displayRows.length | number }}
          </span>
          {{ displayRows.length === 1 ? 'match' : 'matches' }}
          <span
            *ngIf="searchCapped"
            class="tw-text-gray-400 dark:tw-text-gray-500"
            matTooltip="Only the closest matches are shown. Refine your search to narrow the results.">
            · top matches only
          </span>
        </ng-container>
      </div>
      <div
        class="tw-ml-auto"
        [matTooltip]="searchActive ? 'Search results cannot be exported. Clear the search to download the filtered view.' : ''">
        <button
          mat-stroked-button
          (click)="openDownloadDrawer()"
          [disabled]="searchActive || displayRows.length === 0">
          <mat-icon>download</mat-icon>
          Download filtered view
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Changes table -->
  <div
    class="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-bg-white dark:tw-bg-gray-800">
    <div *ngIf="tableLoading" class="tw-flex tw-justify-center tw-py-16">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>

    <div *ngIf="!tableLoading && tableError" class="tw-py-16 tw-text-center">
      <div class="tw-text-base tw-font-medium">We couldn't load the detected changes.</div>
      <button mat-stroked-button class="tw-mt-4" (click)="refreshData()">Try again</button>
    </div>

    <div
      *ngIf="!tableLoading && !tableError && emptyLedger"
      class="tw-px-6 tw-py-16 tw-text-center">
      <mat-icon class="emptyIcon tw-text-gray-300 dark:tw-text-gray-600">work_history</mat-icon>
      <div class="tw-mt-3 tw-text-base tw-font-medium">No job changes detected yet</div>
      <div class="tw-mx-auto tw-mt-1 tw-max-w-md tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
        When Live Data detects that a contact in this ledger has moved to a new company or left
        their job, the change will show up here.
      </div>
    </div>

    <div
      *ngIf="!tableLoading && !tableError && !emptyLedger && displayRows.length === 0"
      class="tw-px-6 tw-py-16 tw-text-center">
      <mat-icon class="emptyIcon tw-text-gray-300 dark:tw-text-gray-600">manage_search</mat-icon>
      <div class="tw-mt-3 tw-text-base tw-font-medium">No changes match your filters</div>
      <button *ngIf="hasActiveFilters" mat-stroked-button class="tw-mt-4" (click)="clearFilters()">
        Clear filters
      </button>
    </div>

    <div
      *ngIf="!tableLoading && !tableError && displayRows.length > 0"
      class="tableViewport"
      (scroll)="onTableScroll($event)">
      <table class="changesTable tw-w-full tw-text-sm">
        <thead>
          <tr>
            <th class="headerCell tw-min-w-[170px]">Person</th>
            <th class="headerCell tw-min-w-[300px]">Job change</th>
            <th class="headerCell tw-min-w-[130px]">Status</th>
            <th class="headerCell tw-min-w-[110px]">Started</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of displayRows; trackBy: trackRow" class="dataRow">
            <td class="bodyCell">
              <div class="tw-flex tw-max-w-[240px] tw-items-center tw-gap-2">
                <span
                  class="tw-min-w-0 tw-truncate tw-font-semibold tw-text-gray-900 dark:tw-text-white"
                  [title]="row.name">
                  {{ row.name }}
                </span>
                <a
                  *ngIf="row.linkedin"
                  [href]="'https://www.linkedin.com/in/' + row.linkedin"
                  target="_blank"
                  rel="noopener"
                  matTooltip="View LinkedIn profile"
                  class="linkedinChip">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="white">
                    <path
                      d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                  </svg>
                </a>
              </div>
            </td>
            <td class="bodyCell">
              <div class="tw-flex tw-items-center tw-gap-3">
                <div class="tw-max-w-[200px]">
                  <div
                    class="tw-truncate tw-text-gray-500 tw-line-through tw-decoration-gray-400 dark:tw-text-gray-400 dark:tw-decoration-gray-500"
                    [title]="row.importedCompany || ''">
                    {{ row.importedCompany || '—' }}
                  </div>
                  <div class="tw-text-xs tw-text-gray-400 dark:tw-text-gray-500">imported</div>
                </div>
                <mat-icon class="jobArrow tw-shrink-0 tw-text-gray-400 dark:tw-text-gray-500">
                  trending_flat
                </mat-icon>
                <div class="tw-max-w-[240px]">
                  <div
                    class="tw-truncate tw-font-semibold tw-text-gray-900 dark:tw-text-white"
                    [title]="row.newCompany || 'None'">
                    {{ row.newCompany || 'None' }}
                  </div>
                  <div
                    *ngIf="row.newTitle"
                    class="tw-truncate tw-text-xs tw-text-gray-500 dark:tw-text-gray-400"
                    [title]="row.newTitle || ''">
                    {{ row.newTitle }}
                  </div>
                </div>
              </div>
            </td>
            <td
              class="bodyCell tw-whitespace-nowrap"
              [title]="
                row.changedAt
                  ? 'Change detected ' + (row.changedAt | date: 'yyyy-MM-dd h:mm a':'UTC') + ' UTC'
                  : ''
              ">
              <span
                *ngIf="row.kind === 'new_company'"
                class="tw-inline-flex tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-full tw-border tw-border-emerald-200 dark:tw-border-emerald-400/30 tw-bg-emerald-50 dark:tw-bg-emerald-500/10 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-emerald-700 dark:tw-text-emerald-300">
                <span class="statDot tw-bg-emerald-500 dark:tw-bg-emerald-400"></span>
                New company
                <ng-container *ngIf="row.olderMove">· older</ng-container>
              </span>
              <span
                *ngIf="row.kind === 'no_employer'"
                class="tw-inline-flex tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-full tw-border tw-border-amber-200 dark:tw-border-amber-400/30 tw-bg-amber-50 dark:tw-bg-amber-400/10 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-amber-700 dark:tw-text-amber-300">
                <span class="statDot tw-bg-amber-500 dark:tw-bg-amber-400"></span>
                No current employer
              </span>
            </td>
            <td class="bodyCell tw-whitespace-nowrap">
              <ng-container *ngIf="row.startedAt; else noStart">
                <div class="tw-font-medium tw-text-gray-900 dark:tw-text-white">
                  {{ row.startedAt | date: 'MMM yyyy':'UTC' }}
                </div>
                <div class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
                  {{ row.startedAgo }}
                </div>
              </ng-container>
              <ng-template #noStart>
                <span class="tw-text-gray-400 dark:tw-text-gray-500">—</span>
              </ng-template>
            </td>
          </tr>
          <tr *ngIf="pageLoading">
            <td colspan="4" class="tw-py-4">
              <mat-spinner [diameter]="24" class="tw-mx-auto"></mat-spinner>
            </td>
          </tr>
          <tr *ngIf="hasMore && !pageLoading">
            <td colspan="4" class="tw-py-3 tw-text-center">
              <button mat-stroked-button (click)="loadNextPage()">Load more</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-ledger-download-drawer [ledger]="ledger" [orgId]="orgId"></app-ledger-download-drawer>
